export class ContactModel {
  public name: string;
  public email: string;
  public message: string;
}
